var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExplore = function SvgExplore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#767676",
    fillRule: "evenodd",
    d: "M30.091 10.26c2.022 7.45-1.602 17.127-10.695 19.597C12 31.866 2.989 26.066.948 18.646.465 16.876.426 14.36.654 12.54s.964-3.733 1.869-5.323c.904-1.59 2.422-3.13 3.865-4.249A13.8 13.8 0 0 1 11.24.551C18.63-1.46 28.069 2.81 30.09 10.26M14.652 26.79C6.962 25.155 1.99 18.573 4.004 12.216c2.408-7.596 8.763-9.705 14.764-8.45 1.43.303 2.787.885 3.994 1.716 1.207.83 2.24 1.89 3.04 3.121a11.24 11.24 0 0 1 1.58 8.418c-1.25 6.036-6.713 11.051-12.73 9.77",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#767676",
    fillRule: "evenodd",
    d: "m10.934 20.54 1.796-8.147 7.605-3.261-1.954 8.101zm5.593-4.687c-.618.424-1.724.337-2.09-.395-.435-.875-.112-1.568.502-1.993a1.282 1.282 0 0 1 1.483.002c.144.102.268.232.364.384.402.636.359 1.577-.259 2.001",
    clipRule: "evenodd"
  })));
};
export default SvgExplore;